import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../types/actionParams';
import { TableAllowedActions } from '../types/TableAllowedActions';

export class GetTableActionsRequest extends Request<ISingleIdParams, TableAllowedActions> {
  constructor(id: string) {
    super('getTableActions', { id: id });
  }
}
